import { initialState } from "./state"

export default {
  setReason: (state, payload) => (state.reason = payload),
  setReasonType: (state, payload) => (state.reason.type = payload),
  setReasonDescription: (state, payload) =>
    (state.reason.description = payload),
  setReasonCategorie: (state, payload) => (state.reason.categorie = payload),
  setUuid: (state, payload) => (state.uuid = payload),
  resetNoteTypes: state => {
    const INITIAL_STATE = initialState()
    Object.keys(INITIAL_STATE).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  }
}
